import { render, staticRenderFns } from "./HelpBlockField.vue?vue&type=template&id=3c64fd9c&"
import script from "./HelpBlockField.vue?vue&type=script&lang=js&"
export * from "./HelpBlockField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c64fd9c')) {
      api.createRecord('3c64fd9c', component.options)
    } else {
      api.reload('3c64fd9c', component.options)
    }
    module.hot.accept("./HelpBlockField.vue?vue&type=template&id=3c64fd9c&", function () {
      api.rerender('3c64fd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help-block/HelpBlockField.vue"
export default component.exports